import axios from "axios";

export default function ProfileFormService(formData) {
  return axios({
    method: 'put',
    url: process.env.REACT_APP_API_HOST + "/api/v2/profile",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
